module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro-5@3x.ver2_0_2.jpg?540cfc29";